module.exports = __webpack_public_path__ + "static/media/airconditioner_cool.e9a5699c.png";